import React from 'react';
import browserHistory from 'react-router/lib/browserHistory';
import match from 'react-router/lib/match';
import Router from 'react-router/lib/Router';
import { render, unmountComponentAtNode } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { setupFeatureFramework } from '@surfline/web-common/dist/features/splitio';
import { identitySelector } from '@surfline/web-common/dist/features/redux';
import '@surfline/quiver-themes/stylesheets/normalize.css';

import configureStore from '../stores';
import config from '../config';

import '../styles/base.scss';

const root = document.querySelector('#root');
const preloadedState = window.__DATA__; // eslint-disable-line no-underscore-dangle
const store = configureStore(preloadedState);
const history = syncHistoryWithStore(browserHistory, store);

const mount = () => {
  // eslint-disable-next-line global-require,import/newline-after-import
  const routes = require('../routes').default;

  match({ history, routes: routes(store) }, (error, redirectLocation, renderProps) => {
    render(
      <AppContainer>
        <Provider store={store} >
          <Router {...renderProps} onUpdate={() => window.scrollTo(0, 0)} />
        </Provider>
      </AppContainer>,
      root,
    );
  });
};

setupFeatureFramework(
  config.appKeys.splitio,
  identitySelector(store.getState()),
).then(mount).catch(mount);

if (module.hot) {
  module.hot.accept('../routes', () => {
    unmountComponentAtNode(root);
    mount();
  });
}



// WEBPACK FOOTER //
// ./src/client/index.js